import { render, staticRenderFns } from "./ClaimDetailSubmenu.vue?vue&type=template&id=8723f3b4"
import script from "./ClaimDetailSubmenu.vue?vue&type=script&lang=js"
export * from "./ClaimDetailSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports